import request from "@/utils/request";

export default function delGroup(groupId) {
    return request({
        url: `/device/deviceGroup/delGroup/${groupId}`,
        method: 'post',
    })
}
